<template>
  <section>
    <!-- Title Page -->
    <section
      class="bg-title-page flex-c-m p-t-160 p-l-15 p-r-15"
      :style="{backgroundImage: 'url(' + activityImages[0] + ')'}"
    ></section>
    <!-- style="background-image: url(/@/../static/images/bg-title-page-04.jpg);" -->
    <!-- Content page -->

    <div class="bread-crumb bo5-b p-t-17 p-b-17">
      <div class="container">
        <router-link to="/" class="txt27">Home</router-link>

        <span class="txt29 m-l-10 m-r-10">/</span>

        <router-link to="/blog" class="txt27">體驗活動</router-link>

        <span class="txt29 m-l-10 m-r-10">/</span>

        <span class="txt29">{{vendorName[0]}}</span>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-8 col-lg-9">
          <div class="p-t-50 p-b-50 bo5-r p-r-50 h-full p-r-0-md bo-none-md">
            <div class="blo4 p-b-63">
              <div class="text-blo4">
                <h4 class="p-b-20">
                  <router-link to="#" class="tit9" style="text-decoration:none">{{activityTitle[0]}}</router-link>
                </h4>
                <div v-for=" index in  activityContent.length">
                  <div class="pic-blo4 hov-img-zoom bo-rad-10 pos-relative">
                    <router-link to="#" v-if="activityImages[index-1] != undefined ">
                      <img :src="activityImages[index-1]" alt="IMG-BLOG">
                    </router-link>
                  </div>
                  <p class="p-t-20 p-b-20" v-html="activityContent[index-1]"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mobileMode">
          <div
            v-if="vendorName[0] != '' && activityIsOpen[0] != false"
            class="sticky-bar mobileMode"
          >
            <div
              style="border-bottom: 1px solid rgba(0,0,0,0.2); padding: 11px 12px 10px 12px;"
              class="openbtn"
              @click="openNav()"
              id="sidebarToogle"
            >
              <div class="btn-booking">
                <a href="##" class="booking-text" style="text-decoration:none">預訂船班</a>
              </div>
            </div>
            <div
              style="border-bottom: 1px solid rgba(0,0,0,0.2); height : 109px; padding: 0 30px;
    text-align: center;"
            >
              <span style="text-align: center;" class="price">{{activityPrice[0]}}</span>
              <span class="sub-info">
                <span>限時優惠</span>
              </span>
            </div>
            <div>
              <div style="margin-bottom: 27px;">
                <div>
                  <span>
                    <i class="material-icons">&#xe532;</i>
                    航行時間:
                    <span>{{activityDuringTIme[0]}}</span>
                    <!-- <span>分鐘</span> -->
                  </span>
                </div>

                <div>
                  <span>
                    <i class="material-icons">&#xe153;</i>
                    集合地點:
                    <span>{{activityAddress[0]}}</span>
                  </span>
                </div>
              </div>
              <div style="padding: 11px 12px 10px 12px;">
                <div class="btn-findSit">
                  <a class="findSit-text" href="##" style="text-decoration:none">找尋空位</a>
                </div>
              </div>
            </div>
          </div>

          <div style="width:270px">
            <div>
              <div class="categories">
                <h4 class="txt33 bo5-b p-b-35 p-t-58">活動資訊</h4>

                <ul>
                  <li class="bo5-b p-t-8 p-b-8">
                    <p href="#" class="txt27">
                      合作店家
                      <span class="m-r-6 m-l-4">|</span>
                      <br>
                      {{vendorName[0]}}
                    </p>
                  </li>
                  <li class="bo5-b p-t-8 p-b-8">
                    <p v-for=" (info,index) in activityInfo"
                       v-if="index%2 == 0 || index == 0 "
                       class="txt27">
                      {{activityInfo[index]}}
                      <span class="m-r-6 m-l-4">|</span>

                      {{activityInfo[index+1]}}
                    </p>
                  </li>
                  <li class="bo5-b p-t-8 p-b-8">
                    <p class="txt27">票價: {{activityPrice[0]}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <aside>
          <div id="mySidebar" class="bookingSidebar">
            <div style="margin-top:10%;">
              <a href="javascript:void(0)" class="closebtn" @click="closeNav()">×</a>
              <div style=" padding:30px;">
                <div style="margin-bottom:10px;">
                  <el-steps :active="active" :space="space" finish-status="success">
                    <el-step title="選擇日期時間"></el-step>
                    <el-step title="選擇人數船隻"></el-step>
                    <el-step title="留下資料"></el-step>
                    <el-step title="完成預定"></el-step>
                  </el-steps>
                </div>
                <div class="block">
                  <span class="demonstration"></span>
                  <div v-if="active == 1" id="datePickerSwitch">
                    <span class="demonstration">請輸入搭船日期:</span>
                    <el-date-picker
                      v-model="dateStart"
                      placeholder="選擇日期"
                      type="date"
                      id="dateData"
                      :picker-options="pickerOptionsDate"
                      @change="dateIsWeekendCheck()"
                    ></el-date-picker>
                  </div>
                  <div v-if="isWeekend == true && active == 1" id="timeType">
                    <span>請輸入您的時間類型:</span>
                    <span>( 您選擇的日期為假日,可以選擇固定班次或自訂時間(自訂時間需要人數大於十人才會開船哦 )</span>
                    <el-radio-group v-model="radioSelectType">
                      <el-radio-button label="固定班次"></el-radio-button>
                      <el-radio-button label="自訂時間"></el-radio-button>
                    </el-radio-group>
                  </div>

                  <div v-if="active == 1" id="dateSelectTime">
                    <span>請輸入搭船時間:</span>
                    <el-time-select
                      v-if="radioSelectType =='自訂時間'"
                      v-model="CustomTimer"
                      :picker-options="{
                      start: '08:00',
                      step: '01:00',
                      end: '18:00'
                    }"
                      placeholder="請選擇出航時間"
                    ></el-time-select>

                    <el-time-select
                      v-if="radioSelectType =='固定班次'"
                      v-model="CustomTimer"
                      :picker-options="{
                      start: '10:00',
                      step: '3:00',
                      end: '22:00',
                    selectableRange: ['09:00:00 - 12:00:00', '16:00:00 - 19:00:00']
                     }"
                      placeholder="請選擇出航時間"
                    ></el-time-select>
                  </div>

                  <div id="numberSelect" v-if="active == 2">
                    <span>請輸入人數:</span>
                    <span>( 人數最多30人,最少１人, 人數需要有10人以上才能選船 ,小於10人只能拼船 )</span>
                    <el-input-number v-model="num" :min="1" :max="30" label="輸入人數"></el-input-number>

                    <div v-if="num >=10">
                      <el-button v-if="active == 2" style="margin-top: 12px;" @click="active++">我要拼船</el-button>
                      <span>請選擇船隻:</span>
                      <el-radio-group v-model="shipType">
                        <div v-for=" (shipData,index) in shipInfo">
                          <el-radio :label="shipData.shipName">{{shipData.shipName}}</el-radio>
                          <img :src="shipData.shipImage" width="300px" height="300px" alt>
                        </div>
                      </el-radio-group>
                    </div>
                  </div>
                  <div v-if="active == 3" id="userInfo">
                    <span>請留下您的聯絡資料:</span>
                    <span>姓名:</span>
                    <el-input placeholder="請輸入您的姓名" v-model="userName" clearable></el-input>
                    <span>手機號碼:</span>
                    <el-input placeholder="請輸入您的電話" v-model="userPhone" clearable></el-input>
                    <span>信箱:</span>
                    <el-input placeholder="請輸入您的email" v-model="userEmail" clearable></el-input>
                  </div>
                  <el-button v-if="active >1" style="margin-top: 12px;" @click="back">上一步</el-button>
                  <el-button v-if="active == 1" style="margin-top: 12px;" @click="step1">下一步</el-button>
                  <el-button v-if="active == 2" style="margin-top: 12px;" @click="step2">下一步</el-button>
                  <el-button v-if="active == 3" style="margin-top: 12px;" @click="step3">下一步</el-button>
                  <el-button v-if="active == 4" style="margin-top: 12px;" @click="closeNav()">完成</el-button>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </section>
</template>

<style scoped>
.sticky-bar {
  background-color: #ffffff;
  -webkit-box-shadow: 4px 4px 18px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 18px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 18px -4px rgba(0, 0, 0, 0.75);
}
.btn-booking {
  text-align: center;
  display: block;
  padding: 0 20px;
  border-radius: 5px;
  width: 245px;
  height: 54px;
  border-radius: 5px;
  background-color: #ffbb00;
}
.btn-findSit {
  text-align: center;
  margin-left: 20px;
  display: block;
  padding: 0 20px;
  border-radius: 5px;
  width: 195px;
  height: 54px;
  border-radius: 5px;
  background-color: #ffbb00;
}
.booking-text {
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  margin-left: 30%;
  margin-top: 16px;
  float: left;
  text-align: center;
  text-decoration: none;
}
.findSit-text {
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  margin-left: 30%;
  margin-top: 16px;
  float: left;
  text-align: center;
  text-decoration: none;
}
.btn-booking:hover {
  background-color: #000000;
}
.btn-findSit:hover {
  background-color: #000000;
}
.price {
  font-family: Roboto;
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffbb00;
  display: block;
  text-align: center;
  margin-top: 34px;
}
.sub-info {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffbb00;
}
.material-icons {
  margin-left: 17px;
  margin-top: 20px;
}
.bookingSidebar {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background: white;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.bookingSidebar a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.bookingSidebar a:hover {
  color: #f1f1f1;
}

.bookingSidebar .closebtn {
  font-size: 36px;
  text-align: right;
  padding-right: 100px;
}
#timeType span {
  display: block;
  margin-bottom: 10px;
}
#numberSelect span {
  margin-top: 10px;
  margin-bottom: 10px;
}
#numberSelect img {
  margin-top: 10px;
  margin-bottom: 10px;
}
#userInfo span {
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
}
.tit9 {
  text-decoration: none;
}
.dis-block {
  text-decoration: none;
}
.bread-crumb a {
  text-decoration: none;
}
.bo5-b a {
  text-decoration: none;
}
.p-b-20 {
  white-space: pre-wrap;
}
@media (max-width: 414px) {
  .mobileMode {
    width: 90%;
    margin-left: 5%;
  }
  .btn-booking {
    width: 100%;
  }
  .booking-text {
    margin-left: 36%;
  }
  .btn-findSit {
    width: 80%;
  }
  .findSit-text {
    margin-left: 40%;
  }
}
</style>
<script >
import { uuid } from "vue-uuid";
import { create } from "domain";

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export default {
  name: "BlogPage",
  data() {
    return {
      panelShow: true,
      uuid: uuid.v1(),
      activity: [],
      radioSelectType: "自訂時間",
      isWeekend: false,
      date: "",
      CustomTimer: "",
      dateStart: "",
      active: 1,
      today: new Date(),
      num: 1,
      shipInfo: [],
      userName: "",
      userPhone: "",
      userEmail: "",
      shipType: "",
      space: "70%",
      activityIsOpen: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          }
        ]
      },
      pickerOptionsDate: {
        disabledDate(time) {
          return time.getTime() < new Date().setDate(new Date().getDate() - 1);
        }
      },
      configBlogDetailInfo: [],
      vendorName: [],
      activityTitle: [],
      activityContent: [],
      activityImages: [],
      activityPrice: [],
      activityInfo: [],
      activityAddress: [],
      activityDuringTIme: []
    };
  },
  props: ["blogConfig"],
  methods: {
    openNav() {
      document.getElementById("mySidebar").style.display = "block";
      document.getElementById("app").style.backgroundColor = "rgba(0,0,0,.3)";
      document.getElementById("mySidebar").style.backgroundColor = "#ffff";
      if (document.body.clientWidth > 414) {
        document.getElementById("mySidebar").style.width = "40%";
      } else {
        document.getElementById("mySidebar").style.width = "100%";
      }
    },
    closeNav() {
      document.getElementById("mySidebar").style.width = "0.001px";
      document.getElementById("app").style.backgroundColor = "#ffff";
      if (this.userName != "" && this.userPhone != "" && this.num != "") {
        let pushUserInfo = firebaseDB.ref(
          "signedUp/activitys/" + this.activity[0] + "/" + this.uuid
        );
        // let tet = firebaseDB.ref("signedUp/activitys/" + this.activity);
        if (this.num < 10) {
          pushUserInfo.set({
            signedAmount: this.num,
            signedDate: formatDate(this.dateStart.toString()),
            signedTime: this.CustomTimer,
            name: this.userName,
            phone: this.userPhone,
            email: this.userEmail,
            createTime: new Date(Date.now()).toLocaleString(),
            updateTime: 0,
            isDelete: false
          });
        } else {
          pushUserInfo.set({
            signedAmount: this.num,
            signedDate: formatDate(this.dateStart.toString()),
            signedTime: this.CustomTimer,
            selectedShipType: this.shipType,
            name: this.userName,
            phone: this.userPhone,
            email: this.userEmail,
            createTime: new Date(Date.now()).toLocaleString(),
            updateTime: 0,
            isDelete: false
          });
        }
      }

      this.active = 1;
      this.isWeekend = false;
      this.radioSelectType = "自訂時間";
      this.CustomTimer = "";
      this.dateStart = "";
      this.num = 1;
      this.shipType = "";
      this.userName = "";
      this.userPhone = "";
      this.userEmail = "";
      this.uuid = uuid.v1();
    },
    step1() {
      if (this.CustomTimer == "" || this.dateStart == "") {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Oops...",
          text: "資料不能空白!"
        });
      } else {
        this.active++;
      }
    },
    step2() {
      this.active++;
    },
    step3() {
      if (this.userName == "" || this.userPhone == "" || this.userEmail == "") {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Oops...",
          text: "資料不能空白!"
        });
      } else if (
        !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.userEmail) &&
        !/^09[0-9]{8}$/.test(this.userPhone)
      ) {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Oops...",
          text: "email 及 手機號碼格式錯誤!"
        });
      } else if (
        !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.userEmail)
      ) {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Oops...",
          text: "email格式錯誤!"
        });
      } else if (!/^09[0-9]{8}$/.test(this.userPhone)) {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Oops...",
          text: "手機號碼格式錯誤!"
        });
      } else {
        this.active++;
      }
    },
    dateIsWeekendCheck() {
      if (this.dateStart != "") {
        let dt = new Date(this.dateStart);
        if (dt.getDay() == 6 || dt.getDay() == 0) {
          this.isWeekend = true;
        } else {
          this.isWeekend = false;
        }
      }
    },
    back() {
      this.active--;
    }
  },
  mounted: function() {
    return new Promise(
      (
        resolve,
        reject,
        data = this.configBlogDetailInfo,
        route = this.$route.params,
        activityRouteName = this.$route.params.activity,
        detailName = this.vendorName,
        title = this.activityTitle,
        content = this.activityContent,
        image = this.activityImages,
        ship = this.shipInfo,
        price = this.activityPrice,
        isopen = this.activityIsOpen,
        info = this.activityInfo,
        whichActivity = this.activity,
        address = this.activityAddress,
        duringTime = this.activityDuringTIme
      ) => {
        const readVendorInfo = firebaseDB.ref("activities");
        readVendorInfo
          .orderByChild("vendorName")
          .on("value", function(snapshot) {
            snapshot.forEach(function(childSnapshot) {
              if (
                childSnapshot.val().vendorNumber == route.vendor &&
                activityRouteName == childSnapshot.val().vendorActivityNum
              ) {
                detailName.push(childSnapshot.val().vendorName);
                title.push(childSnapshot.val().activityTitle);
                price.push(childSnapshot.val().activityPrice);
                isopen.push(childSnapshot.val().activityIsOpen);
                // info.push(childSnapshot.val().activityInfo);
                whichActivity.push(childSnapshot.val().vendorActivityNum);
                address.push(childSnapshot.val().activityAddress);
                duringTime.push(childSnapshot.val().activityDuringTIme);

                console.log(info[1]);

                // let cacheInfo = [];
                // console.log(info[0].length)
                // for( var i = 0 ; i < info[0].length ; i++){

                //   cacheInfo.push(info[0][i]);
                // }
                // info = cacheInfo;

                for (
                  var i = 0;
                  i < childSnapshot.val().activityInfo.length;
                  i++
                ) {
                  info.push(childSnapshot.val().activityInfo[i]);
                }

                for (
                  var i = 0;
                  i < childSnapshot.val().activityContent.length;
                  i++
                ) {
                  content.push(childSnapshot.val().activityContent[i]);
                }
                for (
                  var i = 0;
                  i < childSnapshot.val().activityBlogImages.length;
                  i++
                ) {
                  image.push(childSnapshot.val().activityBlogImages[i]);
                }
                for (var i = 0; i < childSnapshot.val().ship.length; i++) {
                  ship.push(childSnapshot.val().ship[i]);
                }
                //data.push(childSnapshot.val());
              }
              resolve(snapshot.val());
            });
          });
      }
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BlogPageDetail.vue